import { createComponentWithProxy } from "react-fela";
import { layout } from "~/styleguide";

export const SiteMaxWidth = createComponentWithProxy(() => ({
    maxWidth: layout.siteMaxWidth,
    marginH: "auto"
}));

export const ContentMaxWidth = createComponentWithProxy(() => ({
    maxWidth: layout.contentMaxWidth,
    marginH: "auto"
}));
